export default __webpack_public_path__ + "static/media/icon-twitter-colored.7151d233.svg";